module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-prize-sub-about-wrapper"
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "background"
  }, [_c('img', {
    staticClass: "object",
    attrs: {
      "src": require("../assets/car.svg")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-prize-sub-about",
    class: [{
      'is-alt': _vm.isAlt
    }],
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.paragraph.title
    }
  }), _vm._v(" "), _c('div-container', [(_vm.imageUrl) ? _c('div-columns', [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "1rem"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])], 1)], 1), _vm._v(" "), (!_vm.isDesktop) ? _c('div', {
    staticClass: "section-prize-sub-about",
    staticStyle: {
      "text-align": "right",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "object",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "src": require("../assets/car.svg")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf5ba686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutPrizeSubSection.vue
// module id = 937
// module chunks = 1